import { computed } from 'vue'
import { useHead } from '@unhead/vue'
import type { UseHeadOptions } from '@unhead/vue'

export type UseJsonldOptions = Pick<UseHeadOptions, 'tagPosition'>

export default (json: any, options?: UseJsonldOptions) => {
    if (!json) {
        return
    }

    const jsonComputed = computed(() =>
        typeof json === 'function' ? json() : json
    )
    useHead(() => {
        if (!jsonComputed.value) {
            return {}
        }

        return {
            script: [
                {
                    type: 'application/ld+json',
                    innerHTML: JSON.stringify(jsonComputed.value, null, '')
                }
            ]
        }
    }, options)
}
